/* eslint-disable react/prop-types */

import React from 'react'
import { Text } from 'grommet'
import styled from 'styled-components'

import { doc } from './Text.doc'
import { createWithDoc } from '../../utils/helpers'

/**
 *
 * Text
 *
 */

const StyledText = styled(Text).attrs(props => ({ ...props }))`
  font-family: ${props => props.secondary && 'Lato'};
  text-decoration: ${props => props.underline && 'underline'};
  text-transform: ${props => props.capitalize && 'capitalize'};
`
function createText({
  alignSelf,
  a11yTitle,
  as,
  capitalize,
  gridArea,
  margin,
  children,
  color,
  level,
  responsive,
  size,
  textAlign,
  tag,
  truncate,
  underline = false,
  weight,
  wordBreak,
  secondary,
  ...rest
}) {
  return (
    <StyledText
      a11yTitle={a11yTitle}
      alignSelf={alignSelf}
      as={as}
      capitalize={capitalize}
      color={color}
      gridArea={gridArea}
      level={level}
      margin={margin}
      responsive={responsive}
      secondary={secondary}
      size={size}
      tag={tag}
      textAlign={textAlign}
      truncate={truncate}
      underline={underline}
      weight={weight}
      wordBreak={wordBreak}
      {...rest}
    >
      {children}
    </StyledText>
  )
}

export default createWithDoc({
  docFunction: doc,
  component: createText,
})
